/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react';
import { Paper } from '@material-ui/core';

import { formatNumber, getColumnWidth, getNested } from 'app/utils';
import MUIDatePickerFilter from 'app/components/MUIDatePickerFilter';

import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import { debounce } from 'lodash';
import moment from 'moment';

export const DepositsCreatedTable = (props) => {
  const {
    deposits,
    depositsFromdb,
    getAllDeposits,
    reactTableRef,
    firstDate,
    secondDate,
  } = props;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [sorted, setSorted] = useState([]);
  const [filtered, setFiltered] = useState('');

  useEffect(() => {
    if ((firstDate && secondDate) || (!firstDate && !secondDate)) {
      handleFetchData();
    }
  }, [firstDate, secondDate]);

  const colums = [
    {
      Header: () => <strong>ID</strong>,
      accessor: 'id',
      Cell: (row) => {
        return (
          <Link to={handleTable(row)}>
            <div
              style={{
                textAlign: 'center',
              }}
            >
              {row.value}
            </div>
          </Link>
        );
      },
      filterable: false,
    },
    {
      Header: () => <strong>Agencia</strong>,
      accessor: 'agency.name',
      Cell: (row) => {
        return (
          <Link to={handleTable(row)}>
            <div
              style={{
                textAlign: 'center',
              }}
            >
              {row.value}
            </div>
          </Link>
        );
      },
      filterable: false,
    },
    {
      Header: () => <strong>Ubicación ID</strong>,
      accessor: 'locationID',
      Cell: (row) => (
        <Link to={handleTable(row)}>
          <div
            style={{
              textAlign: 'center',
            }}
          >
            {row.value}
          </div>
        </Link>
      ),
      width: 250,
      Filter: (cell) => {
        return (
          // eslint-disable-next-line jsx-a11y/no-onchange
          <select
            onChange={(e) => cell.onChange(e.target.value)}
            value={
              cell.filter && cell.filter.value
                ? cell.filter.value
                : ''
            }
          >
            <option value="">Todos</option>
            <option value="american-express">American-Express</option>
            <option value="fiserv">Fiserv</option>
            <option value="bbva-karlopay">bbva-karlopay</option>
          </select>
        );
      },
      filterable: false,
    },
    {
      Header: () => <strong>Fecha Transacción</strong>,
      accessor: 'transactionDate',
      Cell: (row) => (
        <Link to={handleTable(row)}>
          <div
            style={{
              textAlign: 'center',
            }}
          >
            {row.value
              ? moment(row.value).utc().format('DD/MM/YYYY')
              : '-'}
          </div>
        </Link>
      ),
      filterable: false,
      Filter: (cell) => {
        return <MUIDatePickerFilter cell={cell} />;
      },
      width: getColumnWidth(
        getNested([], depositsFromdb),
        'date',
        'Fecha de pago     ',
      ),
    },
    {
      Header: () => <strong>Tiempo transacción</strong>,
      accessor: 'transactionTime',
      Cell: (row) => (
        <Link to={handleTable(row)}>
          <div
            style={{
              textAlign: 'center',
            }}
          >
            {row.value
              ? moment(row.value, 'HH:mm').format('hh:mm A')
              : '-'}
          </div>
        </Link>
      ),
      filterable: false,
      Filter: (cell) => {
        return <MUIDatePickerFilter cell={cell} />;
      },
      width: getColumnWidth(
        getNested([], depositsFromdb),
        'date',
        'Fecha de pago     ',
      ),
    },
    {
      Header: () => <strong>Total de transacción</strong>,
      accessor: 'transactionAmount',
      Cell: (row) => (
        <Link to={handleTable(row)}>
          <div
            style={{
              textAlign: 'center',
            }}
          >
            {formatNumber(row.value)}
          </div>
        </Link>
      ),
      filterable: false,
    },
  ];

  const handleFetchData = debounce(
    (state, instance) => {
      if (state) {
        getAllDeposits({
          page: state.page,
          pageSize: state.pageSize,
          sorted: state.sorted,
          filtered: state.filtered,
          firstDate,
          secondDate,
        });
        setPage(state.page);
        setPageSize(state.pageSize);
        setSorted(state.sorted);
        setFiltered(state.filtered);
      } else {
        getAllDeposits({
          page,
          pageSize,
          sorted,
          filtered,
          firstDate,
          secondDate,
        });
      }
    },
    1000,
    { leading: false, trailing: true },
  );

  const handleTable = (row) => {
    return `/detail-payments-standalone/${row.original.id}/${row.original.agency.id}`;
  };

  return (
    <Paper>
      <ReactTable
        ref={reactTableRef}
        NoDataComponent={() => (
          <div className="rt-noData">Sin resultados</div>
        )}
        filterable
        manual
        onFetchData={handleFetchData}
        data={getNested([], depositsFromdb)}
        pages={deposits.tablePagesFromdb}
        columns={colums}
        className="-striped -highlight"
        previousText="Anterior"
        nextText="Siguiente"
        loading={deposits.isLoading}
        loadingText="Cargando datos..."
      />
    </Paper>
  );
};
